import { render, staticRenderFns } from "./printdeathcertificate.vue?vue&type=template&id=2cd9255c"
import script from "./printdeathcertificate.vue?vue&type=script&lang=js"
export * from "./printdeathcertificate.vue?vue&type=script&lang=js"
import style0 from "./printdeathcertificate.vue?vue&type=style&index=0&id=2cd9255c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports